export enum SEARCH_SETTINGS {
    /**
     * @value Add extension
     */
    ADD_EXTENSION = 'SEARCH_SETTINGS.ADD_EXTENSION',
    /**
     * @value Add filter
     * @description button to add a filter
     */
    ADD_FILTER = 'ADMIN.SEARCH_SETTINGS.ADD_FILTER',
    /**
     * @value Add a filter
     * @description title of the dialog used to add a filter
     */
    ADD_FILTER_TITLE = 'ADMIN.SEARCH_SETTINGS.ADD_FILTER_TITLE',
    /**
     * @value Add internal source
     */
    ADD_INTERNAL_SOURCE = 'SEARCH_SETTINGS.ADD_INTERNAL_SOURCE',
    /**
     * @value Add result type
     * @description action
     */
    ADD_RESULT_TYPE = 'SEARCH_SETTINGS.ADD_RESULT_TYPE',
    /**
     * @value Apply configuration
     */
    APPLY_CONFIGURATION = 'SEARCH_SETTINGS.APPLY_CONFIGURATION',
    /**
     * @value The %NAME% will be applied on this site.
     *
     * The configuration can be changed afterwards.
     */
    APPLY_CONFIGURATION_WARNING = 'SEARCH_SETTINGS.APPLY_CONFIGURATION_WARNING',
    /**
     * @value Apply
     * @description action for a configuration
     */
    APPLY_CONFIG_SHORT = 'SEARCH_SETTINGS.APPLY_CONFIG_SHORT',
    /**
     * @value Available filters
     */
    AVAILABLE_FILTERS = 'SEARCH_SETTINGS.AVAILABLE_FILTERS',
    /**
     * @value Google cloudsearch
     * @description name of the gcs settings page
     */
    CLOUDSEARCH_SETTINGS = 'SEARCH_SETTINGS.CLOUDSEARCH_SETTINGS',
    /**
     * @value Applied
     * @description status of a configuration
     */
    CONFIG_IS_APPLIED = 'SEARCH_SETTINGS.CONFIG_IS_APPLIED',
    /**
     * @value Custom configuration
     */
    CUSTOM_CONFIGURATION = 'SEARCH_SETTINGS.CUSTOM_CONFIGURATION',
    /**
     * @value The custom configuration can be applied on this site only. Global admins and site admins can manage it.
     */
    CUSTOM_CONFIGURATION_DESC = 'SEARCH_SETTINGS.CUSTOM_CONFIGURATION_DESC',
    /**
     * @value Select which fields should be used in search. User search is based on the main user directory of the default site.
     * @description Description of the user profile custom fields section in search setting admin.
     */
    CUSTOM_FIELD_USER_PROFILE_DESCRIPTION = 'SEARCH_SETTINGS.CUSTOM_FIELD_USER_PROFILE_DESCRIPTION',
    /**
     * @value Use this field in search
     * @description Description of the setting purpose in user profile custom fields section in search settings admin
     */
    CUSTOM_FIELD_USER_PROFILE_SETTING_DESCRIPTION = 'SEARCH_SETTINGS.CUSTOM_FIELD_USER_PROFILE_SETTING_DESCRIPTION',
    /**
     * @value Default configuration
     * @description name of the default configuration
     *
     */
    DEFAULT_CONFIGURATION = 'SEARCH_SETTINGS.DEFAULT_CONFIGURATION',
    /**
     * @value The default configuration is the platform configuration. It is applied by default on each site. Only global admins can manage it.
     * @description default configuration explanation
     */
    DEFAULT_CONFIGURATION_DESC = 'SEARCH_SETTINGS.DEFAULT_CONFIGURATION_DESC',
    /**
     * @value Define
     * @description action to define a new configuration
     */
    DEFINE_CONFIG = 'SEARCH_SETTINGS.DEFINE_CONFIG',
    /**
     * @value Choose the information displayed in the search results. All search engines will be affected.
     * @description Description for the section in search settings related to the displayed information in search results
     */
    DISPLAY_SETTINGS_DESCRIPTION = 'SEARCH_SETTINGS.DISPLAY_SETTINGS_DESC',
    /**
     * @value Displayed information
     * @description Title for the section in search settings related to the displayed information in search results
     */
    DISPLAY_SETTINGS_TITLE = 'SEARCH_SETTINGS.DISPLAY_SETTINGS_TITLE',
    /**
     * @value Drive
     * @description Drive source for search settings
     */
    DRIVE_SOURCE = 'SEARCH_SETTINGS.DRIVE_SOURCE_TITLE',
    /**
     * @value Edit extension
     */
    EDIT_EXTENSION = 'SEARCH_SETTINGS.EDIT_EXTENSION',
    /**
     * @value Edit filter
     */
    EDIT_FILTER = 'SEARCH_SETTINGS.EDIT_FILTER',
    /**
     * @value Edit internal source
     */
    EDIT_INTERNAL_SOURCE = 'SEARCH_SETTINGS.EDIT_INTERNAL_SOURCE',
    /**
     * @value Edit source label
     */
    EDIT_SOURCE_LABEL = 'SEARCH_SETTINGS.EDIT_SOURCE_LABEL',
    /**
     * @value The label is the name displayed in the tabs, in the search results page. By default, the label is the extension name. You can change it and translate it.
     */
    EXTENSION_LABEL_WARNING = 'SEARCH_SETTINGS.EXTENSION_LABEL_WARNING',
    /**
     * @value Extension
     * @description Extension source title for search setting
     */
    EXTENSION_SOURCE = 'SEARCH_SETTINGS.EXTENSION_SOURCE_TITLE',
    /**
     * @value Display results from an installed extension.
     */
    EXTENSION_SOURCE_DESC = 'SEARCH_SETTINS.EXTENSION_SOURCE_DESCRIPTION',
    /**
     * @value Search in an extension
     */
    EXTENSION_SOURCE_TITLE = 'SEARCH_SETTINS.EXTENSION_SOURCE_TITLE',
    /**
     * @value Search a field...
     * @description placeholder displayed to explain the purpose of the search field
     */
    FIELD_SEARCH_PLACEHOLDER = 'ADMIN.SEARCH_SETTINGS.FIELD_SEARCH_PLACEHOLDER',
    /**
     * @value List of all available filters
     */
    FILTERS_LIST = 'SEARCH_SETTINGS.FILTERS_LIST',
    /**
     * @value Filters
     * @description tab label
     */
    FILTERS_TAB = 'ADMIN.SEARCH_SETTINGS.TAB_FILTERS',
    /**
     * @value First search tab
     * @description Title of the first tab (aka default tab) in search settings
     */
    FIRST_TAB = 'SEARCH_SETTINGS.FIRST_TAB_TITLE',
    /**
     * @value The first four options are displayed initially
     */
    FOUR_OPTIONS_DISPLAYED = 'SEARCH_SETTINGS.FOUR_OPTIONS_DISPLAYED',
    /**
     * @value If the call for the Google cloud search API failed, the search engine fallback to the native search.
     */
    GCS_FALLBACK_WARNING = 'SEARCH_SETTINGS.GCS_FALLBACK_WARNING',
    /**
     * @value Cannot get the configuration
     * @description error title displayed when an error occurred on the search settings page
     */
    GLOBAL_ERROR = 'ADMIN.SEARCH_SETTINGS.ERROR_TITLE',
    /**
     * @value Please try to refresh the page in a moment
     * @description description of the error when we cannot display the settings page
     */
    GLOBAL_ERROR_EXPLANATION = 'ADMIN.SEARCH_SETTINGS.ERROR_SUBTITLE',
    /**
     * @value Author
     * @description Label for the setting that allow displaying author in search results
     */
    HIDE_AUTHOR = 'SEARCH_SETTINGS.HIDE_AUTHOR_LABEL',
    /**
     * @value Iframe
     * @description Iframe source for search settings
     */
    IFRAME_SOURCE = 'SEARCH_SETTINGS.IFRAME_SOURCE_TITLE',
    /**
     * @value The four first filters are initially visible. User can click “more filters” to display all filters.
     */
    INFO_MESSAGE_FACETS = 'SEARCH_SETTINGS.INFO_MESSAGE_FACETS',
    /**
     * @value The label is the name displayed in the tabs, in the search results page. By default, the label is the source name. You can change it and translate it.
     */
    INTERNAL_SOURCE_LABEL_WARNING = 'SEARCH_SETTINGS.INTERNAL_SOURCE_LABEL_WARNING',
    /**
     * @value Expanded by default
     */
    IS_EXPANDED = 'SEARCH_SETTINGS.IS_EXPANDED',
    /**
     * @value LumApps
     * @description Name of the lumapps source for search results settings
     */
    LUMAPPS_SOURCE = 'SEARCH_SETTINGS.LUMAPPS_SOURCE_TITLE',
    /**
     * @value Display results from the platform.
     */
    LUMAPPS_SOURCE_DESC = 'SEARCH_SETTINS.LUMAPPS_SOURCE_DESCRIPTION',
    /**
     * @value Search in an internal source
     */
    LUMAPPS_SOURCE_TITLE = 'SEARCH_SETTINS.LUMAPPS_SOURCE_TITLE',
    /**
     * @value Lumwork
     * @description Lumwork source title for search settings
     */
    LUMWORK_SOURCE = 'SEARCH_SETTINGS.LUMWORK_SOURCE_TITLE',
    /**
     * @value Microsoft
     * @description Miscrosft source for search settings
     */
    MICROSOFT_SOURCE = 'SEARCH_SETTINGS.MICROSOFT_SOURCE_TITLE',
    /**
     * @value Native search
     */
    NATIVE_SEARCH = 'SEARCH_SETTINGS.NATIVE_SEARCH',
    /**
     * @value There are no filters
     * @description Label displayed when there are no filters configured
     */
    NO_FILTERS = 'ADMIN.SEARCH_SETTINGS.NO_FILTERS',
    /**
     * @value This section lists all filters available in search.
     */
    NO_FILTERS_DESCRIPTION = 'SEARCH_SETTINGS.NO_FILTERS_DESCRIPTION',
    /**
     * @value No filters yet
     */
    NO_FILTERS_YET = 'SEARCH_SETTINGS.NO_FILTERS_YET',
    /**
     * @value Original name: %NAME%
     */
    ORIGINAL_TAB_NAME = 'SEARCH_SETTINGS.ORIGINAL_TAB_NAME',
    /**
     * @value {"one":"Other search tab","other":"Other search tabs"}
     * @description Title for the tab(s) that are not in first position
     */
    OTHER_TAB = 'SEARCH_SETTINGS.OTHER_TAB_TITLE',
    /**
     * @value Results page
     * @description title of the configuration page
     */
    RESULTS_SETTINGS = 'SEARCH_SETTINGS.RESULTS_SETTINGS',
    /**
     * @value Result types
     */
    RESULT_TYPES = 'SEARCH.FILTER_RESULT_TYPES',
    /**
     * @value List of all indexed result types
     */
    RESULT_TYPES_LIST = 'SEARCH_SETTINGS.RESULT_TYPES_LIST',
    /**
     * @value Save configuration
     */
    SAVE_CONFIGURATION = 'SEARCH_SETTINGS.SAVE_CONFIGURATION',
    /**
     * @value The %NAME% is currently applied. The recent changes will be visible by everyone immediately.
     *
     * This action can’t be reverted.
     */
    SAVE_CONFIGURATION_WARNING = 'SEARCH_SETTINGS.SAVE_CONFIGURATION_WARNING',
    /**
     * @value See details
     * @description label of the button to display configuration details
     */
    SEE_CONFIG = 'SEARCH_SETTINGS.SEE_CONFIG',
    /**
     * @value Select source
     */
    SELECT_LUMAPPS_SOURCE = 'SEARCH_SETTINS.SELECT_LUMAPPS_SOURCE',
    /**
     * @value SharePoint
     * @description SharePoint source for search settings
     */
    SHAREPOINT_SOURCE = 'SEARCH_SETTINGS.SHAREPOINT_SOURCE_TITLE',
    /**
     * @value Source configurations
     * @description name of the section listing configurations
     */
    SOURCE_CONFIGURATIONS = 'SEARCH_SETTINGS.SOURCE_CONFIGURATIONS',
    /**
     * @value On the results page, the search results are organized into sources. Use the default configuration or define the custom configuration to reorganize and hide sources and result types.
     * @description explanation of the section
     */
    SOURCE_CONFIGURATIONS_EXPLANATION = 'SEARCH_SETTINGS.SOURCE_CONFIGURATIONS_EXPLANATION',
    /**
     * @value Only users from the selected groups will see this tab in the search result page. Platform and site groups can be selected in the custom configuration.
     * @description Helper displayed below the group picker in search settings for custom configuration.
     */
    SOURCE_VISIBILITY_GROUP_PICKER_HELPER_CUSTOM = 'SEARCH_SETTINGS.SOURCE_VISIBILITY_GROUP_PICKER_HELPER_CUSTOM',
    /**
     * @value Only users from the selected groups will see this tab in the search result page. Only platform groups can be selected in the default configuration.
     * @description Helper displayed below the group picker in search settings.
     */
    SOURCE_VISIBILITY_GROUP_PICKER_HELPER_DEFAULT = 'SEARCH_SETTINGS.SOURCE_VISIBILITY_GROUP_PICKER_HELPER_DEFAULT',
    /**
     * @value Tab visibility
     * @description Title of the section that allow user to select groups for tab visibility. If a group is selected, only users who are part of this group will be allowed to see this tab in search results page.
     */
    SOURCE_VISIBILITY_SECTION_TITLE = 'SEARCH_SETTINGS.SOURCE_VISIBILITY_SECTION_TITLE',
    /**
     * @value Search settings
     * @description title of the page search settings
     */
    TITLE = 'SEARCH_SETTINGS.TITLE',
    /**
     * @value Separate each field with a comma. Ex: email,firstname,location
     * @description Helper text for the "user profile fields" form field of the search settings admin page.
     * The example "email,firstname,location" must remain in english as they are technical terms and must not have any spaces between commas.
     */
    USER_PROFILE_FIELDS_HELPER = 'ADMIN.SEARCH_SETTINGS.USER_PROFILE_FIELDS_HELPER',
    /**
     * @value User profile fields
     * @description Label of the "User profile fields" form field of the search settings admin page.
     */
    USER_PROFILE_FIELDS_LABEL = 'ADMIN.SEARCH_SETTINGS.USER_PROFILE_FIELDS_LABEL',
    /**
     * @value Zendesk
     * @description Zendesk source title for search settings
     */
    ZENDESK_SOURCE = 'SEARCH_SETTINGS.ZENDESK_SOURCE_TITLE',
}
